import script from "./PartnerList.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerList.vue?vue&type=script&setup=true&lang=js"

import "./PartnerList.vue?vue&type=style&index=0&id=bd6a9a82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6a9a82"]])

export default __exports__